import Popup from 'reactjs-popup'
import '../../styles/userpage.css'
import Bookitem from './bookitem'

const completed = ({ books, updateStateToExistingBook, setJournalBookTitle, setJournalTitle, setJournalContent,
    setTitle, setStatus, setCurrentPage, journalOptions, handleAddJournal, filterJournals, handleUpdateBook }) => {
    return (
        (books
            .filter((book) => book["status"] === "Completed").length > 0)
            ?
            books.filter((book) => book["status"] === "Completed").map((book) => <div
                onMouseEnter={() => { updateStateToExistingBook(book); setJournalBookTitle(book.name); setJournalTitle("Untitled") }}
                className="py-3 inprogress-item">
                <Bookitem
                    filterJournals={filterJournals}
                    handleAddJournal={handleAddJournal}
                    setTitle={setTitle}
                    setStatus={setStatus}
                    setCurrentPage={setCurrentPage}
                    handleUpdateBook={handleUpdateBook}
                    book={book} />
                <hr className="completed-line"></hr> </div>)
                :
                <div className="font-extralight text-sm">No books have been logged yet</div>)

}

export default completed;